import { html, LitElement, TemplateResult } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { FILTER_WIZARD_STORE, FilterWizardStore } from 'components/discovery/filter-wizard/filter-wizard-store.js'
import { AttributeValue } from 'components/discovery/shared/search/typing/filter-attributes.js'
import { ImageDisplayConfig } from 'components/discovery/filter-wizard/typing/config.js'
import { inject } from '@cloudsuite/mosaic-shared/scripts/dependency-injection.js'
import { ifDefined } from 'lit/directives/if-defined.js'

@customElement('csc-attribute-value-image')
export class CSCAttributeValueImage extends LitElement {
  @inject(FILTER_WIZARD_STORE)
  private filterWizardStore!: FilterWizardStore

  @property({ type: Object, attribute: 'attribute-value' })
  attributeValue!: AttributeValue

  @property({ type: Object, attribute: 'image-config' })
  imageConfig?: ImageDisplayConfig

  override connectedCallback() {
    super.connectedCallback()
    this.setAttribute('id', `attribute-value-${this.attributeValue.id}`)
  }

  private optionClicked() {
    if (this.attributeValue.disabled) return

    this.filterWizardStore.search(this.attributeValue)
    this.attributeValue.selected = !this.attributeValue.selected
    this.requestUpdate()
  }

  private selectableState() {
    if (this.attributeValue.disabled) return 'disabled'
    return this.attributeValue.selected ? 'selected' : 'selectable'
  }

  override render(): TemplateResult {
    return html`
      <cse-selectable
        state="${this.selectableState()}"
        @click="${this.optionClicked}"
      >
        <cse-image
          source="${this.attributeValue.picture}"
          height="${ifDefined(this.imageConfig?.height ?? 75)}"
          width="${ifDefined(this.imageConfig?.width)}"
          fit="${ifDefined(this.imageConfig?.fit)}"
        ></cse-image>
        <cse-text class="title" variant="body-s">
          ${this.attributeValue.name}
        </cse-text>
      </cse-selectable>
    `
  }
}
